var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M16.564 7.9c0 .828-.716 1.5-1.6 1.5h-12.8c-.884 0-1.6-.672-1.6-1.5s.716-1.5 1.6-1.5h12.8c.884 0 1.6.672 1.6 1.5z","key":0}),React.createElement("path",{"d":"M8.5 16c-.828 0-1.5-.716-1.5-1.6V1.6C7 .716 7.672 0 8.5 0S10 .716 10 1.6v12.8c0 .884-.672 1.6-1.5 1.6z","key":1})]));
}

Add.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16"};

module.exports = Add;

Add.default = Add;
